import React from "react";
import { useSelector } from "react-redux";
import MetaData from "../Layouts/MetaData";
import Sidebar from "../User/Sidebar";
import Product from "./Product";

// Empty Wishlist Component
const EmptyWishlist = () => (
  <div className="flex items-center flex-col gap-2 m-6">
    <img
      draggable="false"
      className="object-contain"
      src="https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/mywishlist-empty_39f7a5.png"
      alt="Empty Wishlist"
    />
    <span className="text-lg font-medium mt-6">Empty Wishlist</span>
    <p>You have no items in your wishlist. Start adding!</p>
  </div>
);

const Wishlist = () => {
  const { wishlistItems } = useSelector((state) => state.wishlist);

  return (
    <>
      <MetaData
        title="Your Wishlist | Ladies Fashion - Trendy Apparel & Accessories"
        description="Save your favorite clothing and accessories to your wishlist. Explore the latest trends in ladies' fashion and shop your wishlist items at Siddhi Creatives."
        keywords="wishlist, ladies fashion, women's clothing, trendy outfits, accessories, save items, online shopping"
        url="https://www.siddhicreatives.com/wishlist"
      />

      <main className="w-full mt-1 sm:mt-24">
        <div className="flex gap-3.5 mt-20 sm:mt-6 sm:mx-3 m-auto mb-7">
          <Sidebar activeTab={"wishlist"} />

          <div className="flex-1 shadow bg-white">
            <div className="flex flex-col">
              <span className="font-medium text-lg px-4 sm:px-8 py-4 border-b">
                My Wishlist ({wishlistItems.length})
              </span>

              {/* Show Empty Wishlist if no items */}
              {wishlistItems.length === 0 ? (
                <EmptyWishlist />
              ) : (
                wishlistItems
                  .reverse()
                  .map((item, index) => <Product {...item} key={index} />)
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Wishlist;
